export const FETCH_PRIVILEGES_BASE = 'FETCH_PRIVILEGES';
export const FETCH_PRIVILEGES_PENDING = 'FETCH_PRIVILEGES_PENDING';
export const FETCH_PRIVILEGES_REJECTED = 'FETCH_PRIVILEGES_REJECTED';
export const FETCH_PRIVILEGES_FULFILLED = 'FETCH_PRIVILEGES_FULFILLED';
